export default function StepButtons({
    step,
    showMore,
    onToggleShowMore,
    onBack,
    onContinue,
    isFinal = false
}) {

    const toggleText   = showMore ? 'Mostrar Menos' : 'Mostrar Más';
    const toggleIcon   = showMore ? 'expand_less'   : 'expand_more';
    const continueText = isFinal  ? 'Enviar'        : 'Guardar y Continuar';

    const handleContinue = () => {
        onContinue();
    };

    return (
        <div className="step-buttons d-flex justify-content-between mt-3">
            <div>
                {step <= 4 && (
                    <button
                        type="button"
                        className="btn-toggle"
                        onClick={onToggleShowMore}
                    >
                        {toggleText}
                        <i className="material-icons ms-1">{toggleIcon}</i>
                    </button>
                )}
            </div>
            <div>
                {step > 1 && (
                    <button
                        type="button"
                        className="btn-back me-2"
                        onClick={onBack}
                    >
                        Anterior
                    </button>
                )}
                <button
                    type="button"
                    className="btn-primary d-inline-flex align-items-center guardar-continuar-btn no-border"
                    onClick={handleContinue}
                >
                    {continueText}
                    {!isFinal && (
                        <i
                            className="material-icons ms-2"
                            style={{ fontSize: '1.2rem' }}
                        >
                            arrow_forward
                        </i>
                    )}
                </button>
            </div>
        </div>
    );
}